<template>
  <div class="business-person">
    <common-layout>
      <div slot="header">
        <h3>技术转移顾问团队</h3>
      </div>
      <div slot="container">
        <div class="business-person.header">
          <el-button class="business-person.addBtn" @click="$router.go(-1)">返回上一页</el-button>
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="add"
            style="background: #623AA2; border: none;"
          >
            新增
          </el-button>
          <section>
            <el-input
              style="margin-right:10px;"
              placeholder="请输入用户姓名"
              v-model="paramsObj.keyword"
              class="input-with-select"
              clearable
              @change="search"
            >
              <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>
            <label style="margin-right: 10px; line-height: 40px; min-width: 60px">发布平台:</label>
            <el-select
              style="width: 300px"
              v-model="srelease"
              clearable
              placeholder="请选择发布平台"
              @change="resourceChange"
            >
              <el-option label="双平台" :value="1" />
              <el-option label="大市场平台" :value="2" />
              <el-option label="成果交易平台" :value="3" />
            </el-select>
            <!-- <el-button type="warning" class="active-detail.addBtn" @click="importExcel">导入</el-button> -->
          </section>
        </div>
        <div class="active-detail.table">
          <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="headerStyle">
            <el-table-column type="index" label="序号" align="center" width="90">
              <template slot-scope="scope">
                <span>{{ scope.$index + (paramsObj.page - 1) * paramsObj.pageSize + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="consultantName" label="姓名" width="180" align="center"></el-table-column>
            <el-table-column
              prop="certificateNo"
              label="聘书编号"
              width="180"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="industryField"
              label="行业领域"
              width="180"
              align="center"
            ></el-table-column>
            <el-table-column prop="position" label="职务" align="center">              
              <template slot-scope="scope">
                <div v-show="scope.row.position == 1">顾问总监</div>
                <div v-show="scope.row.position == 2">顾问经理</div>
                <div v-show="scope.row.position == 3"> 顾问助理</div>
              </template>
            </el-table-column>
            <el-table-column prop="city" label="地区" align="center"></el-table-column>
            <el-table-column label="发布平台" align="center">
              <template slot-scope="scope">
                {{
                  scope.row.isAchievement	 === 1 && scope.row.isMarket === 1
                    ? '双平台'
                    : scope.row.isMarket === 1
                    ? '大市场平台'
                    : '成果交易平台'
                }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination">
          <div class="grid-content bg-purple-light">
            <el-pagination
              @current-change="handleCurrentChange"
              layout="total, prev, pager, next,jumper"
              :total="total"
              :current-page.sync="paramsObj.page"
              :page-size="paramsObj.pageSize"
            ></el-pagination>
          </div>
        </div>
      </div>
    </common-layout>
    <el-dialog
      title="技术转移顾问团队"
      :visible.sync="dialogVis"
      width="30%"
      :close-on-click-modal="false"
      @closed="is_submit = true"
    >
      <el-form :model="form" :rules="rules" label-width="80px" ref="form">
        <el-form-item label="姓名" prop="consultantName">
          <el-input v-model="form.consultantName" autocomplete="off" placeholder="请填写姓名"></el-input>
        </el-form-item>
        <el-form-item label="聘书编号" prop="certificateNo">
          <el-input
            v-model="form.certificateNo"
            autocomplete="off"
            placeholder="请填写聘书编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idCard">
          <el-input v-model="form.idCard" autocomplete="off" placeholder="请填写身份证号"></el-input>
        </el-form-item>
        <el-form-item label="行业领域" prop="industryField">
          <el-select
            v-model="form.industryField"
            style="width: 100%;"
            clearable
            placeholder="请选择行业领域"
            @change="industryFieldChange"
          >
            <el-option :label="item.label" :value="item.label" v-for="item in guaranteeTypeList" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职务" prop="position">
          <el-select
            v-model="form.position"
            style="width: 100%;"
            clearable
            placeholder="请选择职务"
          >
            <el-option label="顾问总监" :value="1"></el-option>
            <el-option label="顾问经理" :value="2"></el-option>
            <el-option label="顾问助理" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地区" prop="area">
          <v-distpicker
            style="text-align: left"
            @selected="citySelected"
            :province="form.area"
            hide-area
            :city="form.city"
          ></v-distpicker>
        </el-form-item>
        <el-form-item label="同步发布" prop="isMarket" style="text-align: left">
          <el-select
            v-model="isMarket"
            placeholder="请选择"
            style="width: 100%"
            @change="formmarket"
          >
            <el-option label="双平台" :value="1" />
            <el-option label="大市场平台" :value="2" />
            <el-option label="成果交易平台" :value="3" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVis = false">取 消</el-button>
        <el-button type="primary" @click="createPerson">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonLayout from '../../components/common-layout.vue';
export default {
  components: {
    CommonLayout,
  },
  data() {
    return {
			listUrl: `${urlConfig.devUrl}apij2/admin-api/trade/talent-consultant/page`,
      is_submit: true,
      srelease: '',
      headerStyle: {
        color: '#623AA2',
        background: '#E5F3FE',
      },
      guaranteeTypeList: [],
      total: 20,
      tableData: [],
      dialogVis: false,
      operate: 'add',
      isMarket: 1,
      paramsObj: {
        page: 1,
        pageSize: 10,
        keyword: '',

      },
      form: {
        consultantName: '',
        certificateNo: '',
        industryField: '',
        position: "", // 职务
        idCard: '',
        area: '甘肃省',
        city: '兰州市',
        isMarket: 1,
        isAchievement	: 1,
      },
      rules: {
        consultantName: [
          {
            required: true,
            message: '请填写姓名',
            trigger: 'blur',
          },
        ],
        certificateNo: [
          {
            required: true,
            message: '请填写证书编号',
            trigger: 'blur',
          },
        ],
        industryField: [
          {
            required: true,
            message: '请选择行业领域',
            trigger: 'change',
          },
        ],
        position: [
          {
            required: true,
            message: '请选择职务',
            trigger: 'change',
          },
        ],
        idCard: [
          {
            required: true,
            message: '请填写身份证号',
            trigger: 'blur',
          },
        ],
        area: [
          {
            required: true,
            message: '请选择所属区域',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {    
    // 获取数据字典
    getGroup() {
      let obj = {
        dictTypes: ["financial_industry"]
      }
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/system/dict-data/getGroup`, obj).then(
        (response) => {
          if (response.code == 0) {
            console.log('response', response)
            this.guaranteeTypeList = response.data.financial_industry            
          } else {
            this.$message.error(response.status);
          }
        },
        (error) => {}
      );
    },
    add() {
      this.dialogVis = true;
      this.operate = 'add';
      this.form.id = '';
      this.form.consultantName = '';
      this.form.certificateNo = '';
      this.form.industryField = '';
      this.form.position = '';
      this.form.idCard = '';
      this.form.area = '甘肃省';
      this.form.city = '兰州市';
      this.form.isMarket = 1;
      this.form.isAchievement	 = 1;
      this.isMarket = 1;
    },
    courseIdChange(val) {
    },
    industryFieldChange(val) {
      console.log('val', val);
    },
    handleEdit(row) {
      this.operate = 'edit';
      this.dialogVis = true;
      this.form.id = row.id;
      this.form.consultantName = row.consultantName;
      this.form.certificateNo = row.certificateNo;
      this.form.industryField = row.industryField;
      this.form.position = row.position;
      this.form.idCard = row.idCard;
      this.form.area = row.area;
      this.form.city = row.city;
      this.form.isMarket = row.isMarket;
      this.isMarket =
      row.isAchievement	 === 1 && row.isMarket === 1
          ? 1
          : row.isMarket === 1 && row.isAchievement === 2
          ? 2
          : 3;
      console.log('this.isMarket', this.isMarket)
    },
    handleDelete(row) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
        .then(() => {
          let obj = {
            ids: [row.id]
          }
          this.http.delete(`${urlConfig.devUrl}apij2/admin-api/trade/talent-consultant/delete`, obj).then(res => {
            if (res.code == 0) {
              this.paramsObj.page = 1
              this.getData();
              this.$message({
                type: 'success',
                message: '删除成功',
              });
            } else {
              this.$message({
                message: '失败！',
                type: 'error',
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    formmarket(val) {
      if (val === 1) {
        this.form.isMarket = 1;
        this.form.isAchievement	 = 1;
      } else if (val === 2) {
        this.form.isMarket = 1;
        this.form.isAchievement	 = 2;
      } else {
        this.form.isMarket = 2;
        this.form.isAchievement	 = 1;
      }
    },
    //城市选择
    citySelected(e) {
      this.form.address = e;
      this.form.area = e.province.value;
      this.form.city = e.city.value;
    },
    search() {
      this.getData();
    },
    resourceChange() {
      console.log('this.srelease', this.srelease)
      if(!this.srelease) {
        delete this.paramsObj.isMarket
        delete this.paramsObj.isAchievement
      }else{
        if(this.srelease === 1) {
          this.paramsObj.isMarket = 1
          this.paramsObj.isAchievement = 1
        }else if(this.srelease === 2) {
          this.paramsObj.isMarket = 1
          this.paramsObj.isAchievement = 2
        }else{
          this.paramsObj.isMarket = 2
          this.paramsObj.isAchievement = 1
        }
      }
      this.search()
    },
    getData() {
      this.http.post(this.listUrl, this.paramsObj).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.total = res.data.total;
        } else {
          this.$message.error('获取数据失败！！');
        }
      });
    },
    handleCurrentChange(val) {
      this.paramsObj.page = val;
      this.getData();
    },
    createPerson() {
      if (!this.is_submit) {
        return false;
      }
      this.is_submit = false;
      this.$refs['form'].validate(valid => {
        if (valid) {
          let obj = {
            consultantName: this.form.consultantName,
            industryField: this.form.industryField,
            idCard: this.form.idCard,
            certificateNo: this.form.certificateNo,
            area: this.form.area,
            city: this.form.city,
            position: this.form.position,
            isMarket: this.form.isMarket,
            isAchievement	: this.form.isAchievement	,
          };
          if (this.operate == 'add') {
            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/trade/talent-consultant/create`, obj)
              .then(res => {
                if (res.code == 0) {
                  this.$message.success('新增成功');
                  this.isMarket = 1;
                  this.dialogVis = false;
                  this.getData();
                } else {
                  this.is_submit = true;
                }
              })
              .catch(err => {
                this.is_submit = true;
              });
          } else {
            obj.id = this.form.id
            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/trade/talent-consultant/update`, obj)
              .then(res => {
                if (res.code == 0) {
                  this.$message.success('编辑成功');
                  this.isMarket = 1;
                  this.dialogVis = false;
                  this.getData();
                } else {
                  this.is_submit = true;
                }
              })
              .catch(err => {
                this.is_submit = true;
              });
          }
        } else {
          this.is_submit = true;
        }
      });
    },
  },
  mounted() {
    this.getData();
		this.getGroup()
  },
};
</script>

<style lang="scss">
@include component(business-person) {
  width: 100%;
  height: 100%;
  @include part(header) {
    display: flex;
    justify-content: flex-start;
    @include component(el-input) {
      width: 300px;
    }
    section {
      margin-left: 50px;
    }
  }
  @include part(searchBtn) {
    margin-left: 10px;
    margin-right: 30px;
  }
  @include part(addBtn) {
    margin-left: 30px;
  }
  @include part(table) {
    margin-top: 30px;
  }
}
</style>
